import React from 'react';
import { Flex, Container } from '@chakra-ui/react';
import { CollectJS } from './common/components/CollectJS';
import { CheckoutNavBar } from './CheckoutNavBar';
import { useForm, FormProvider } from 'react-hook-form';
import { useMount } from 'react-use';
import { useOrder } from '@olo-web/domain/orders/queries/useOrder';
import { useCheckoutState, useGlobalUIState, useModalDispatch } from '@olo-web/client-state';
import { CheckoutMeta } from './CheckoutMeta';
import { Footer } from '@olo-web/components/molecules/Footer';
import { BackToMenuButton } from '@olo-web/components/atoms/BackToMenuButton';
import { InteractionProofLayer } from '@olo-web/components/atoms/InteractionProofLayer';
import { useIsCheckoutPage, useIsDineIn, useIsScanAndPayPage } from '@olo-web/utils/common/hooks';

type TFormValues = {
  payments: [
    {
      amount: string;
      giftCardInfo: any;
      id: string;
      name: string; // paymentMethod
      surchargesAmount: string;
      tipAmount: string;
      totalAmount: string;
      creditCardInfo: {
        cardNumber: string; // '...4444'
        cardType: string;
        mobilePaymentType: string | null;
        zipCode: string;
      };
    }
  ];
};

export const Checkout = ({ children }: { children: any | JSX.Element[] }) => {
  const { isLoading } = useCheckoutState();
  const { routerLoading } = useGlobalUIState();
  const isCheckoutPage = useIsCheckoutPage();
  const isDineIn = useIsDineIn();
  const modalDispatch = useModalDispatch();
  const isScanAndPay = useIsScanAndPayPage();
  const formMethods = useForm<TFormValues>({
    mode: 'onChange',
    shouldUnregister: false,
  });
  const { refetch } = useOrder();

  useMount(() => {
    modalDispatch({ type: 'CLOSE_MODAL' });
    refetch();
  });

  return (
    <FormProvider {...formMethods}>
      <Flex align="stretch" flexDir="column" bg="base.50" minH="100vh" w="100vw">
        {(isLoading || routerLoading) && <InteractionProofLayer />}
        <CheckoutMeta />
        <CheckoutNavBar />
        {isCheckoutPage && !isDineIn && !isScanAndPay && <BackToMenuButton mt={3} />}
        <Container
          role="main"
          maxW="container.xl"
          flex={1}
          pt={{ base: 0, md: 6 }}
          px={{ base: 0, md: 42 }}
        >
          {children}
        </Container>
        <Footer />
      </Flex>
      <CollectJS />
    </FormProvider>
  );
};
